import styled, { createGlobalStyle } from 'styled-components';
import ReactModal from 'react-modal';

import { media } from 'helpers/breakpoints';

import { withOpacity } from 'helpers/Theme/Theme';
import { ModalStyledProps } from './Modal.typed';

// Overwrites "ReactModal__Overlay"
const GlobalOverlayStyle = createGlobalStyle<{ openTimeout: number }>`
  .react-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: ${({ theme }) => theme.zIndices.MODAL};
    transition: ${({ openTimeout }) => `all ${openTimeout}ms ease-in-out`};

    &.ReactModal__Overlay--after-open {
      background-color: ${({ theme }) =>
        withOpacity(theme.colors.GREY_DARKER, 0.8)};
    }

    &.ReactModal__Overlay--before-close {
      background-color: none;
    }
  }
`;

// Overwrites "ReactModal__Content"
const Modal = styled(ReactModal)<ModalStyledProps>`
  position: fixed;
  background-color: ${({ theme }) => theme.colors.WHITE};
  transform: ${({ offScreenTransform }) => offScreenTransform};
  top: ${({ top }) => top};
  right: ${({ right }) => right};
  bottom: ${({ bottom }) => bottom};
  left: ${({ left }) => left};
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  border-radius: ${({ borderRadius }) => borderRadius};
  padding: ${({ padding }) => padding};

  .ReactModal__Overlay--after-open & {
    opacity: 1;
    transition: ${({ openTimeout }) =>
      openTimeout ? `all ${openTimeout}ms ease-out` : ''};
    transform: ${({ onScreenTransform }) => onScreenTransform};
  }

  .ReactModal__Overlay--before-close & {
    opacity: 0;
    transition-property: all;
    transition-time-function: ease-in;
    // On close, the modal returns to its initial position
    transform: ${({ offScreenTransform }) => offScreenTransform};
  }

  ${media.medium} {
    top: ${({ topMedium }) => topMedium};
    right: ${({ rightMedium }) => rightMedium};
    bottom: ${({ bottomMedium }) => bottomMedium};
    left: ${({ leftMedium }) => leftMedium};
    width: ${({ widthMedium }) => widthMedium};
    height: ${({ heightMedium }) => heightMedium};
    border-radius: ${({ borderRadiusMedium }) => borderRadiusMedium};
    padding: ${({ paddingMedium }) => paddingMedium};
    transform: ${({ offScreenTransformMedium }) => offScreenTransformMedium};

    .ReactModal__Overlay--after-open & {
      transform: ${({ onScreenTransformMedium }) => onScreenTransformMedium};
    }
    .ReactModal__Overlay--before-close & {
      transform: ${({ offScreenTransformMedium }) => offScreenTransformMedium};
    }
  }

  ${media.large} {
    top: ${({ topLarge }) => topLarge};
    right: ${({ rightLarge }) => rightLarge};
    bottom: ${({ bottomLarge }) => bottomLarge};
    left: ${({ leftLarge }) => leftLarge};
    width: ${({ widthLarge }) => widthLarge};
    height: ${({ heightLarge }) => heightLarge};
    border-radius: ${({ borderRadiusLarge }) => borderRadiusLarge};
    padding: ${({ paddingLarge }) => paddingLarge};
    transform: ${({ offScreenTransformLarge }) => offScreenTransformLarge};

    .ReactModal__Overlay--after-open & {
      transform: ${({ onScreenTransformLarge }) => onScreenTransformLarge};
    }
    .ReactModal__Overlay--before-close & {
      transform: ${({ offScreenTransformLarge }) => offScreenTransformLarge};
    }
  }
`;

const ModalContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const ScrollableBody = styled.div`
  flex-grow: 1;
  overflow-y: scroll;
`;

export { Modal, GlobalOverlayStyle, ModalContent, ScrollableBody };
